import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import type {Context} from '../types';

// If a video embed has text block properties, remove them
export default (context: Context) => {
  const {
    node: {jsonNode},
    fn: {__DEPRECATED__dropChildren},
  } = context;
  const {data = {}} = jsonNode;
  const hasChildren = Boolean(jsonNode.children && jsonNode.children.length);
  const defaultTextDivHtml = 'This is some text inside of a div block.';

  return {
    needed: DomTypeUtils.isVideo(data) && data.text,
    logData: {
      msg: 'Video embed with Text Block properties',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // eslint-disable-next-line webflow/no-delete
      delete data.text;

      // Remove the v value if it was set to the default Text Block string and not changed.
      if (jsonNode.v && jsonNode.v === defaultTextDivHtml) {
        // eslint-disable-next-line webflow/no-delete
        delete jsonNode.v;
      }

      if (hasChildren) {
        __DEPRECATED__dropChildren(jsonNode);
      }
    },
  };
};
